import React from 'react';
import { motion } from 'framer-motion';
interface GlowButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  variant?: 'gold' | 'purple';
  className?: string;
}
export function GlowButton({
  children,
  onClick,
  href,
  variant = 'gold',
  className = ''
}: GlowButtonProps) {
  const isGold = variant === 'gold';
  const gradientClass = isGold ? 'bg-gradient-to-r from-gold-warm via-gold to-gold-light' : 'bg-gradient-to-r from-purple-electric-deep via-purple-electric to-purple-electric-light';
  const glowClass = isGold ? 'shadow-glow-gold' : 'shadow-glow-purple';
  const hoverGlowClass = isGold ? 'shadow-glow-gold-lg' : 'shadow-glow-purple-lg';
  const content = <motion.span className={`
        relative inline-flex items-center justify-center
        px-8 py-4 rounded-md
        font-sans font-bold text-sm tracking-wider uppercase
        text-void
        ${gradientClass}
        ${glowClass}
        cursor-pointer
        transition-shadow duration-500
        hover:${hoverGlowClass}
        ${className}
      `} whileHover={{
    scale: 1.03,
    boxShadow: isGold ? '0 0 35px rgba(212, 168, 83, 0.5), 0 0 70px rgba(212, 168, 83, 0.2)' : '0 0 35px rgba(139, 92, 246, 0.5), 0 0 70px rgba(139, 92, 246, 0.2)'
  }} whileTap={{
    scale: 0.98
  }} transition={{
    type: 'spring',
    stiffness: 400,
    damping: 25
  }} data-id="element-94">
      {children}
    </motion.span>;
  if (href) {
    return <a href={href} onClick={onClick} className="inline-block" data-id="element-95">
        {content}
      </a>;
  }
  return <button onClick={onClick} className="inline-block" data-id="element-96">
      {content}
    </button>;
}